var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var EnvironmentalIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 51,
    glyphHeight: 62
  }), React.createElement("path", {
    d: "M25.6399 0.196289C25.6399 0.196289 0.573242 19.663 0.573242 33.5296C0.573242 47.3963 10.7066 55.3963 23.5066 56.463V62.863H27.7732V56.463C40.5732 55.663 50.7066 46.5963 50.7066 33.5296C50.7066 19.663 25.6399 0.196289 25.6399 0.196289ZM27.7732 48.1963V42.863L36.8399 33.7963L33.9066 30.863L27.7732 36.9963V21.263H23.5066V36.9963L17.3732 30.863L14.4399 33.7963L23.5066 42.863V48.1963C16.0399 47.3963 8.83991 42.863 8.83991 33.7963C8.83991 28.463 17.3732 18.5963 25.6399 11.3963C34.4399 19.3963 42.4399 28.9963 42.4399 33.7963C42.4399 42.863 35.2399 47.663 27.7732 48.1963Z"
  }));
};
export var EnvironmentalIconGlyph = function (props) {
  return React.createElement(EnvironmentalIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};